import React from "react";
import PropTypes from "prop-types";
import Resilient from "react-resilient";
import FatalErrorScreen from "@zendesk/knowledge-components/lib/FatalErrorScreen";
import notifyError from "utils/notifyError";

const reportError = error => notifyError("ErrorBoundary", error);

const ErrorBoundary = ({ children }) => (
  <Resilient FallbackComponent={FatalErrorScreen} onError={reportError}>
    {children}
  </Resilient>
);

ErrorBoundary.propTypes = {
  children: PropTypes.node,
};

export default ErrorBoundary;



// WEBPACK FOOTER //
// ./src/components/ErrorBoundary/index.js